import { combineReducers } from 'redux';
import { routerStateReducer } from 'redux-router';

import user from './user';
import order from './order';
import tours from './tours';

const rootReducer = combineReducers({
  user : user,
  tours: tours,
  order: order,
  router : routerStateReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/common/reducers/index.js